import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import NavBar from './components/NavBar';
import Home from './pages/Home';
import Services from './pages/Services';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Footer from './components/Footer';
import Contact from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';
import WaveNotify from './pages/WaveNotify';
import WaveSync from './pages/WaveSync';
import BestShopifyApps from './pages/BestShopifyApps';
import BestInventoryApps from './pages/BestInventoryApps';
import HowToSyncProducts from './pages/HowToSyncProducts';
import BlogIndex from './pages/BlogIndex';
import PageTransition from './components/PageTransition';
import SoldOutProductsRestock from './pages/SoldOutProductsRestock';
import CustomSolutionsForBusinesses from './pages/CustomSolutionsForBusinesses';
import Process from './pages/Process';
import HowWeSolveProblems from './pages/HowWeSolveProblems';

function App() {
  const location = useLocation();
  
  return (
    <>
      <ScrollToTop />
      <NavBar />
      <PageTransition>
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/wavenotify" element={<WaveNotify />} />
          <Route path="/wavesync" element={<WaveSync />} />
          <Route path="/process" element={<Process />} />
          <Route path="/blog" element={<BlogIndex />} />

          <Route path="/blog/how-we-solve-problems" element={<HowWeSolveProblems />} />

          <Route path="/blog/custom-solutions-for-businesses" element={<CustomSolutionsForBusinesses />} />

          <Route path="/blog/sold-out-products-restock" element={<SoldOutProductsRestock />} />
          <Route path="/blog/best-shopify-apps" element={<BestShopifyApps />} />
          <Route path="/blog/best-inventory-apps" element={<BestInventoryApps />} />
          <Route path="/blog/how-to-sync-products" element={<HowToSyncProducts />} />
        </Routes>
      </PageTransition>
      <Footer />
    </>
  );
}

export default App;